import type React from 'react';
import styles from './sign-in-prompt.module.scss';

export interface SignInPromptProps {
  /** Muted lead-in text. Pass null for the action alone. */
  prefix?: React.ReactNode;
  /** The underlined, link-styled action. */
  action?: React.ReactNode;
  onAction: () => void;
  className?: string;
}

/**
 * A muted prefix followed by an underlined action, e.g. "Have an account? Sign in", or the action alone.
 * The whole line is one button.
 */
export const SignInPrompt: React.FC<SignInPromptProps> = ({
  prefix = 'Have an account?',
  action = 'Sign in',
  onAction,
  className,
}) => (
  <button type="button" className={[styles.prompt, className].filter(Boolean).join(' ')} onClick={onAction}>
    {prefix ? <>{prefix} </> : null}
    <span className={styles.action}>{action}</span>
  </button>
);
